/**
 * Módulo Pedidos: lista, estadísticas, reembolsos, productos vendidos e historial local.
 */

const PEDIDOS_POR_PAGINA = 50;
const PEDIDOS_POLL_MS = 45000;

function pedidosState(win) {
	if (!win._posknPedidosAdminState) {
		win._posknPedidosAdminState = {
			pedidosActuales: [],
			paginaActual: 1,
		};
	}
	return win._posknPedidosAdminState;
}

function getAjaxUrl(win) {
	const cfg = win.POSKN_API_CONFIG || {};
	return cfg.ajaxUrl || win.ajaxurl || 'pos-ajax.php';
}

function getNonce(win) {
	return win.posNonce || (win.POSKN_API_CONFIG && win.POSKN_API_CONFIG.posNonce) || '';
}

function metodoEsBs(win, metodo) {
	if (typeof win.posknMetodoEsBs === 'function') return win.posknMetodoEsBs(metodo);
	const m = String(metodo || '').toLowerCase();
	if (!m) return false;
	const map = win.POSKN_METODO_MONEDA || {};
	if (Object.prototype.hasOwnProperty.call(map, m)) {
		return String(map[m]).toUpperCase() === 'BS';
	}
	return m.indexOf('-bs') !== -1 || m.indexOf('_bs') !== -1;
}

function localDateIso() {
	const d = new Date();
	const y = d.getFullYear();
	const m = String(d.getMonth() + 1).padStart(2, '0');
	const day = String(d.getDate()).padStart(2, '0');
	return `${y}-${m}-${day}`;
}

function normalizePedidosList(response) {
	if (Array.isArray(response)) return response;
	if (response && Array.isArray(response.pedidos)) return response.pedidos;
	if (response && response.success && Array.isArray(response.data)) return response.data;
	if (response && Array.isArray(response.data)) return response.data;
	return [];
}

function normalizePedidosStats(response) {
	if (!response || response.error) return null;
	if (response.success && response.data && typeof response.data === 'object' && !Array.isArray(response.data)) {
		return response.data;
	}
	if (response.pedidos_hoy !== undefined || response.ventas_hoy !== undefined) return response;
	return null;
}

function buildPedidosQuery($, extra = {}) {
	const query = {
		estado: $('#filtro-estado').val() || '',
		...extra,
	};
	const fecha = ($('#filtro-fecha').val() || '').trim();
	if (fecha) {
		query.fecha_inicio = fecha;
		query.fecha_fin = fecha;
	}
	if (extra.limite) query.limit = extra.limite;
	return query;
}

function fetchPedidosList(win, $, extra = {}) {
	const api = win.POSKN && win.POSKN.api;
	if (api && typeof api.listOrders === 'function') {
		return api.listOrders(buildPedidosQuery($, extra));
	}
	return $.ajax({
		url: getAjaxUrl(win),
		method: 'POST',
		dataType: 'json',
		data: buildPedidosAjaxData(win, $, extra),
	});
}

function fetchPedidosStats(win) {
	const api = win.POSKN && win.POSKN.api;
	if (api && typeof api.getOrdersStats === 'function') {
		return api.getOrdersStats();
	}
	return $.ajax({
		url: getAjaxUrl(win),
		method: 'POST',
		dataType: 'json',
		data: {
			action: 'poskn_get_pedidos_stats',
			nonce: getNonce(win),
		},
	});
}

function buildPedidosAjaxData(win, $, extra = {}) {
	const data = {
		action: 'poskn_get_pedidos',
		nonce: getNonce(win),
		estado: $('#filtro-estado').val() || '',
		...extra,
	};
	const fecha = ($('#filtro-fecha').val() || '').trim();
	if (fecha) {
		data.fecha_inicio = fecha;
		data.fecha_fin = fecha;
	}
	return data;
}

function applyPedidosStatsLabels($, response) {
	if (!response) return;
	const pedLbl = response.etiqueta_pedidos || 'Pedidos de hoy';
	const venLbl = response.etiqueta_ventas || 'Ventas de hoy';
	if ($('#label-pedidos-resumen').length) {
		$('#label-pedidos-resumen').text(pedLbl);
		$('#label-ventas-resumen').text(venLbl);
		return;
	}
	const $cards = $('.pedidos-resumen .resumen-card');
	if ($cards.length >= 2) {
		$cards.eq(0).find('h4').text(pedLbl);
		$cards.eq(1).find('h4').text(venLbl);
	}
}

function escapeHtml(str) {
	return String(str || '')
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

/** WooCommerce devuelve precios como HTML; extraer texto legible ($1,50). */
function plainTextFromHtml(value) {
	const str = String(value ?? '');
	if (!str || str.indexOf('<') === -1) return str;
	const tmp = document.createElement('div');
	tmp.innerHTML = str;
	return (tmp.textContent || tmp.innerText || str).trim();
}

function formatReceiptPrice(value) {
	return escapeHtml(plainTextFromHtml(value));
}

function formatCreditPaymentLine(win, p, tasa) {
	const metodo = String(p.metodo || '').replace(/-/g, ' ').toUpperCase();
	const monto = parseFloat(p.monto) || 0;
	const esCredito = /credito/i.test(String(p.metodo || ''));
	const simbolo = metodoEsBs(win, p.metodo) ? 'Bs. ' : '$';
	const refHtml = p.referencia
		? ` <span style="color:#1565c0;">[Ref: ${escapeHtml(p.referencia)}]</span>`
		: '';
	let line = `${escapeHtml(metodo)}: ${simbolo}${monto.toFixed(2)}${refHtml}`;
	if (esCredito) {
		const t = Number(tasa || win.TASA_DOLAR || 1) || 1;
		const credUsd = monto > 0 ? monto : 0;
		line += ` <small style="color:#666;">(Bs. ${(credUsd * t).toFixed(2)})</small>`;
	}
	return line;
}

function initPedidosAdminEvents(win, $) {
	if (win._posknPedidosAdminBound) return;
	win._posknPedidosAdminBound = true;

	$(document).on('click', '#filtrar-pedidos', () => win.cargarPedidos());
	$(document).on('change', '#filtro-fecha, #filtro-estado', () => win.cargarPedidos());
	$(document).on('click', '.pedidos-subtab', function onPedidosSubtab() {
		const tab = $(this).data('tab');
		$('.pedidos-subtab')
			.removeClass('active')
			.css({ background: '#f0f0f0', color: '#333' });
		$(this).addClass('active').css({ background: '#2196F3', color: 'white' });
		$('.pedidos-panel').hide();
		$(`#panel-${tab}`).show();
		if (tab === 'productos-vendidos') win.cargarProductosVendidosCaja();
		if (tab === 'todos-productos-vendidos') win.cargarTodosProductosVendidos();
	});
}

export function attachPedidosAdminGlobals(win, $) {
	initPedidosAdminEvents(win, $);
	const state = () => pedidosState(win);

	win.posknRefreshPedidosUi = function posknRefreshPedidosUi(refreshList = false) {
		const pedidosVisible = $('#modulo-pedidos').is(':visible');
		if ((refreshList || pedidosVisible) && typeof win.cargarPedidos === 'function') {
			win.cargarPedidos();
			return;
		}
		if (typeof win.cargarEstadisticasPedidos === 'function') {
			win.cargarEstadisticasPedidos();
		}
		if ($('#panel-productos-vendidos').is(':visible') && typeof win.cargarProductosVendidosCaja === 'function') {
			win.cargarProductosVendidosCaja();
		}
	};

	win.posknStartPedidosPoll = function posknStartPedidosPoll() {
		if (win._posknPedidosPollTimer) return;
		win._posknPedidosPollTimer = win.setInterval(() => {
			if (typeof win.posknIsOfflineMode === 'function' && win.posknIsOfflineMode()) return;
			if ($('#modulo-pedidos').is(':visible')) {
				win.posknRefreshPedidosUi(false);
			}
		}, PEDIDOS_POLL_MS);
	};

	win.posknStopPedidosPoll = function posknStopPedidosPoll() {
		if (win._posknPedidosPollTimer) {
			win.clearInterval(win._posknPedidosPollTimer);
			win._posknPedidosPollTimer = null;
		}
	};

	win.cargarPedidos = function cargarPedidos(pagina = 1) {
		$('#tabla-pedidos').html(
			'<div style="text-align: center; padding: 40px;"><div class="loading-spinner"></div><br>Cargando pedidos...</div>',
		);

		fetchPedidosList(win, $)
			.done((response) => {
				const list = normalizePedidosList(response);
				state().pedidosActuales = list;
				win.mostrarPedidos(list);
				win.cargarEstadisticasPedidos();
			})
			.fail((xhr) => {
				let errorMsg = 'Error al cargar pedidos. Intenta nuevamente.';
				if (xhr && xhr.responseText) {
					try {
						const errorResponse = JSON.parse(xhr.responseText);
						errorMsg = errorResponse.error || errorResponse.data || errorMsg;
					} catch (e) {
						errorMsg = `${errorMsg} (${xhr.status}: ${xhr.statusText})`;
					}
				} else if (xhr && xhr.data) {
					errorMsg = xhr.data || errorMsg;
				}
				$('#tabla-pedidos').html(
					`<div style="text-align: center; padding: 40px; color: #d63638;">❌ ${escapeHtml(errorMsg)}</div>`,
				);
			});
	};

	win.abrirHistorialTickets = function abrirHistorialTickets() {
		$('#modal-historial-tickets').css('display', 'flex');
		let arr = [];
		try {
			arr = JSON.parse(win.localStorage.getItem('historial_pedidos') || '[]');
		} catch (e) {
			arr = [];
		}
		if (!Array.isArray(arr)) arr = [];
		arr = arr.slice().reverse();
		const tasa = typeof win.TASA_DOLAR !== 'undefined' ? win.TASA_DOLAR : 1;
		let html = '';
		if (arr.length === 0) {
			html =
				'<p style="text-align: center; color: #666; padding: 20px;">No hay tickets en el historial local.</p>';
		} else {
			html =
				'<table style="width:100%; border-collapse: collapse; font-size: 13px;">';
			html +=
				'<thead><tr style="background: #f0f0f0;"><th style="padding: 8px; text-align: left;">Número</th><th style="padding: 8px; text-align: left;">Fecha</th><th style="padding: 8px; text-align: right;">Total USD</th><th style="padding: 8px; text-align: right;">Total Bs</th><th style="padding: 8px;">WC #</th></tr></thead><tbody>';
			const max = 200;
			for (let i = 0; i < Math.min(arr.length, max); i++) {
				const p = arr[i];
				const num = p.numero || '-';
				const fecha = p.fecha || '-';
				const totalUsd =
					p.total && p.total.usd != null
						? p.total.usd
						: p.items && Array.isArray(p.items)
							? p.items.reduce(
									(s, it) =>
										s + (parseFloat(it.price) || 0) * (parseFloat(it.cantidad) || 0),
									0,
								)
							: 0;
				const totalBs =
					p.total && p.total.bs != null ? p.total.bs : totalUsd * tasa;
				const wc =
					p.wc_order_number != null
						? p.wc_order_number
						: p.wc_order_id != null
							? p.wc_order_id
							: '-';
				html += `<tr style="border-bottom: 1px solid #eee;"><td style="padding: 8px;">${escapeHtml(num)}</td><td style="padding: 8px;">${escapeHtml(fecha)}</td><td style="padding: 8px; text-align: right;">$${parseFloat(totalUsd).toFixed(2)}</td><td style="padding: 8px; text-align: right;">Bs. ${parseFloat(totalBs).toFixed(2)}</td><td style="padding: 8px;">${escapeHtml(wc)}</td></tr>`;
			}
			html += '</tbody></table>';
			if (arr.length > max) {
				html += `<p style="margin-top: 10px; color: #666; font-size: 12px;">Mostrando los últimos ${max} de ${arr.length}.</p>`;
			}
		}
		$('#historial-tickets-body').html(html);
	};

	win.cargarProductosVendidosCaja = function cargarProductosVendidosCaja() {
		const $cont = $('#productos-vendidos-caja-container');
		if (!$cont.length) return;
		$cont.html(
			'<p style="padding: 20px; color: #666;">Cargando productos vendidos de esta caja...</p>',
		);
		$.ajax({
			url: getAjaxUrl(win),
			method: 'POST',
			dataType: 'json',
			data: {
				action: 'pos_productos_vendidos_caja',
				nonce: getNonce(win),
				_t: Date.now(),
			},
			success(response) {
				if (!response || !response.success) {
					$cont.html(
						'<p style="padding: 20px; color: #666;">No se pudo cargar. Intenta de nuevo.</p>',
					);
					return;
				}
				const productos =
					response.data && response.data.productos ? response.data.productos : [];
				if (productos.length === 0) {
					$cont.html(
						'<p style="padding: 20px; color: #666;">No hay productos vendidos en esta caja aún. Los pedidos facturados con la caja actual aparecerán aquí.</p>',
					);
					return;
				}
				let html =
					'<div style="max-height: 55vh; overflow-y: auto; border: 1px solid #ddd; border-radius: 4px; background: #fff;">';
				html += '<table style="width:100%; border-collapse: collapse; font-size: 13px;">';
				html +=
					'<thead><tr style="background: #2196F3; color: white;"><th style="padding: 10px; text-align: left;">Producto</th><th style="padding: 10px; text-align: right;">Cantidad</th><th style="padding: 10px; text-align: right;">Total</th></tr></thead><tbody>';
				let totalUnidades = 0;
				let totalVenta = 0;
				productos.forEach((p) => {
					const name = (p.name || p.product_name || '').toString();
					const qty = parseInt(p.quantity, 10) || 0;
					const total = parseFloat(p.total) || 0;
					totalUnidades += qty;
					totalVenta += total;
					html += `<tr style="border-bottom: 1px solid #eee;"><td style="padding: 8px 10px;">${escapeHtml(name) || '—'}</td><td style="padding: 8px 10px; text-align: right;">${qty}</td><td style="padding: 8px 10px; text-align: right;">$${total.toFixed(2)}</td></tr>`;
				});
				html += '</tbody></table></div>';
				html += `<p style="margin-top: 12px; font-size: 14px; color: #333;"><strong>Total unidades en esta caja:</strong> ${totalUnidades} &nbsp;|&nbsp; <strong>Total venta (productos):</strong> $${totalVenta.toFixed(2)}</p>`;
				$cont.html(html);
			},
			error() {
				$cont.html(
					'<p style="padding: 20px; color: #d63638;">Error al cargar. Comprueba que tengas una caja abierta e intenta de nuevo.</p>',
				);
			},
		});
	};

	win.cargarTodosProductosVendidos = function cargarTodosProductosVendidos() {
		const $cont = $('#todos-productos-vendidos-container');
		const $resumen = $('#todos-productos-vendidos-resumen');
		if (!$cont.length) return;
		const desde = $('#productos-vendidos-fecha-desde').val() || '';
		const hasta = $('#productos-vendidos-fecha-hasta').val() || '';
		$cont.html(
			'<p style="padding: 20px; color: #666;">Cargando todos los productos vendidos...</p>',
		);
		if ($resumen.length) $resumen.text('');
		$.ajax({
			url: getAjaxUrl(win),
			method: 'POST',
			dataType: 'json',
			data: {
				action: 'pos_productos_vendidos_todos',
				start_date: desde,
				end_date: hasta,
				_t: Date.now(),
			},
			success(response) {
				if (!response || !response.success) {
					$cont.html('<p style="padding: 20px; color: #666;">No se pudo cargar.</p>');
					return;
				}
				const productos =
					response.data && response.data.productos ? response.data.productos : [];
				const totalUnidades =
					response.data && response.data.total_unidades != null
						? response.data.total_unidades
						: 0;
				const startDate =
					response.data && response.data.start_date ? response.data.start_date : desde;
				const endDate =
					response.data && response.data.end_date ? response.data.end_date : hasta;
				if ($resumen.length) {
					$resumen.html(
						`<strong>Período:</strong> ${escapeHtml((startDate || '').split(' ')[0])} – ${escapeHtml((endDate || '').split(' ')[0])} &nbsp;|&nbsp; <strong>Total unidades:</strong> ${totalUnidades}`,
					);
				}
				if (productos.length === 0) {
					$cont.html(
						'<p style="padding: 20px; color: #666;">No hay productos vendidos en el período seleccionado.</p>',
					);
					return;
				}
				let html = '<table style="width:100%; border-collapse: collapse; font-size: 13px;">';
				html +=
					'<thead><tr style="background: #f5f5f5;"><th style="padding: 10px; text-align: left;">Producto</th><th style="padding: 10px; text-align: right;">Cantidad vendida</th></tr></thead><tbody>';
				productos.forEach((p) => {
					const name = (p.name || p.product_name || '').toString();
					const qty = parseInt(p.quantity, 10) || 0;
					html += `<tr style="border-bottom: 1px solid #eee;"><td style="padding: 8px 10px;">${escapeHtml(name) || '—'}</td><td style="padding: 8px 10px; text-align: right;">${qty}</td></tr>`;
				});
				html += '</tbody></table>';
				$cont.html(html);
			},
			error() {
				$cont.html(
					'<p style="padding: 20px; color: #d63638;">Error al cargar. Intenta de nuevo.</p>',
				);
			},
		});
	};

	win.mostrarPedidos = function mostrarPedidos(pedidos) {
		if (!Array.isArray(pedidos) || pedidos.length === 0) {
			$('#tabla-pedidos').html(
				'<div style="text-align: center; padding: 40px; color: #666;">📋 No hay pedidos para mostrar</div>',
			);
			return;
		}

		let html = '<div class="pedidos-tabla">';
		pedidos.forEach((pedido) => {
			const estadoClass = pedido.estado.toLowerCase().replace(' ', '-');
			const estadoBadge = `<span class="estado-badge estado-${estadoClass}">${escapeHtml(pedido.estado)}</span>`;
			html += `
				<div class="pedido-item" data-id="${pedido.id}">
					<span><strong>#${pedido.id}</strong></span>
					<span>${escapeHtml(pedido.cliente)}</span>
					<span><strong>$${parseFloat(pedido.total).toFixed(2)}</strong></span>
					<span>${estadoBadge}</span>
					<div class="pedido-acciones">
						<button class="btn-accion btn-reimprimir" onclick="reimprimirPedido(${pedido.id})" title="Reimprimir">📄</button>
						${
							pedido.estado !== 'Reembolsado'
								? `<button class="btn-accion btn-reembolsar" onclick="reembolsarPedido(${pedido.id}, ${pedido.total})" title="Reembolsar">💰</button>`
								: ''
						}
					</div>
				</div>
			`;
		});
		html += '</div>';
		$('#tabla-pedidos').html(html);
	};

	win.mostrarPaginacion = function mostrarPaginacion(paginacionInfo) {
		let totalPedidos;
		let totalPaginas;

		if (typeof paginacionInfo === 'object' && paginacionInfo.total_pedidos) {
			totalPedidos = paginacionInfo.total_pedidos;
			totalPaginas = paginacionInfo.total_paginas;
		} else {
			totalPedidos = paginacionInfo;
			totalPaginas = Math.ceil(totalPedidos / PEDIDOS_POR_PAGINA);
		}

		const paginaActual = state().paginaActual;

		if (totalPedidos < PEDIDOS_POR_PAGINA) {
			$('#paginacion-pedidos').html('');
			return;
		}

		let html =
			'<div class="paginacion-pedidos" style="text-align: center; margin: 20px 0; padding: 10px;">';

		if (paginaActual > 1) {
			html += `<button onclick="cargarPedidos(${paginaActual - 1})" class="btn-paginacion" style="margin: 0 5px; padding: 8px 12px; background: #4CAF50; color: white; border: none; border-radius: 4px; cursor: pointer;">← Anterior</button>`;
		}

		for (let i = Math.max(1, paginaActual - 2); i <= Math.min(totalPaginas, paginaActual + 2); i++) {
			const activo = i === paginaActual ? 'background: #2E7D32;' : 'background: #4CAF50;';
			html += `<button onclick="cargarPedidos(${i})" class="btn-paginacion" style="margin: 0 2px; padding: 8px 12px; ${activo} color: white; border: none; border-radius: 4px; cursor: pointer;">${i}</button>`;
		}

		if (paginaActual < totalPaginas) {
			html += `<button onclick="cargarPedidos(${paginaActual + 1})" class="btn-paginacion" style="margin: 0 5px; padding: 8px 12px; background: #4CAF50; color: white; border: none; border-radius: 4px; cursor: pointer;">Siguiente →</button>`;
		}

		html += `<span style="margin-left: 15px; color: #666; font-size: 14px;">Página ${paginaActual} de ${totalPaginas} (${totalPedidos} pedidos total)</span>`;
		html += '</div>';
		$('#paginacion-pedidos').html(html);
	};

	win.cargarTodosPedidos = function cargarTodosPedidos() {
		$('#tabla-pedidos').html(
			'<div style="text-align: center; padding: 40px;"><div class="loading-spinner"></div><br>Cargando todos los pedidos...</div>',
		);

		fetchPedidosList(win, $, { limite: 1000 })
			.done((response) => {
				const list = normalizePedidosList(response);
				state().pedidosActuales = list;
				state().paginaActual = 1;
				win.mostrarPedidos(list);
				$('#paginacion-pedidos').html(
					'<div style="text-align: center; margin: 20px 0; color: #666; font-size: 14px;">📋 Mostrando todos los pedidos (sin paginación)</div>',
				);
				win.cargarEstadisticasPedidos();
			})
			.fail(() => {
				$('#tabla-pedidos').html(
					'<div style="text-align: center; padding: 40px; color: #d63638;">❌ Error al cargar todos los pedidos. Intenta nuevamente.</div>',
				);
			});
	};

	win.cargarEstadisticasPedidos = function cargarEstadisticasPedidos() {
		fetchPedidosStats(win)
			.done((response) => {
				const stats = normalizePedidosStats(response);
				if (!stats) return;
				applyPedidosStatsLabels($, stats);
				$('#pedidos-hoy').text(stats.pedidos_hoy || 0);
				const vEquiv =
					stats.ventas_hoy_equiv_usd !== undefined && stats.ventas_hoy_equiv_usd !== null
						? parseFloat(stats.ventas_hoy_equiv_usd)
						: parseFloat(stats.ventas_hoy || 0);
				$('#ventas-hoy').text(`$${vEquiv.toFixed(2)}`);
				const credUsd = parseFloat(stats.ventas_credito_total || 0) || 0;
				const tasa = typeof win.TASA_DOLAR !== 'undefined' ? win.TASA_DOLAR : 1;
				$('#ventas-credito-total').html(
					`$${credUsd.toFixed(2)}<br><small style="font-weight:normal;color:#E65100;">Bs. ${(credUsd * tasa).toFixed(2)}</small>`,
				);
			});
	};

	win.reimprimirPedido = function reimprimirPedido(orderId) {
		$.ajax({
			url: getAjaxUrl(win),
			method: 'POST',
			dataType: 'json',
			data: {
				action: 'poskn_get_order_receipt',
				nonce: getNonce(win),
				order_id: orderId,
			},
			success(response) {
				if (response.success && response.data) {
					win.mostrarReciboModal(response.data);
				} else {
					win.mostrarNotificacion('❌ Error al obtener el recibo', 'error');
				}
			},
			error() {
				win.mostrarNotificacion('❌ Error de conexión', 'error');
			},
		});
	};

	function cerrarModalReembolso() {
		const el = document.getElementById('modal-reembolso-poskn');
		if (!el) return;
		el.remove();
		document.removeEventListener('keydown', onReembolsoEscape);
	}

	function onReembolsoEscape(e) {
		if (e.key === 'Escape') {
			cerrarModalReembolso();
		}
	}

	function enviarReembolsoPedido(orderId, confirmationCode, onDone) {
		$.ajax({
			url: getAjaxUrl(win),
			method: 'POST',
			dataType: 'json',
			data: {
				action: 'poskn_refund_order',
				nonce: getNonce(win),
				order_id: orderId,
				confirmation_code: confirmationCode,
			},
			success(response) {
				if (response.success) {
					cerrarModalReembolso();
					win.mostrarNotificacion('✅ Pedido reembolsado correctamente', 'success');
					win.cargarPedidos();
					if (typeof win.cargarEstadoCaja === 'function') {
						win.setTimeout(() => win.cargarEstadoCaja(), 500);
					}
					if (typeof onDone === 'function') onDone(true);
					return;
				}
				win.mostrarNotificacion(
					`❌ Error: ${response.data?.message || 'Error desconocido'}`,
					'error',
				);
				if (typeof onDone === 'function') onDone(false);
			},
			error(xhr) {
				let errorMsg = 'Error de conexión al procesar el reembolso';
				if (xhr.responseText) {
					try {
						const errorResponse = JSON.parse(xhr.responseText);
						errorMsg = errorResponse.data?.message || errorResponse.data || errorMsg;
					} catch (e) {
						errorMsg = `${errorMsg}: ${xhr.statusText}`;
					}
				}
				win.mostrarNotificacion(`❌ ${errorMsg}`, 'error');
				if (typeof onDone === 'function') onDone(false);
			},
		});
	}

	win.reembolsarPedido = function reembolsarPedido(orderId, total) {
		cerrarModalReembolso();
		const totalFmt = (parseFloat(total) || 0).toFixed(2);
		const modal = document.createElement('div');
		modal.id = 'modal-reembolso-poskn';
		modal.style.cssText =
			'display:flex;position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.7);z-index:100010;align-items:center;justify-content:center;';
		modal.innerHTML = `
			<div role="dialog" aria-modal="true" aria-labelledby="reembolso-titulo" style="background:#fff;padding:28px 24px;border-radius:10px;max-width:420px;width:92%;box-shadow:0 8px 28px rgba(0,0,0,0.35);">
				<h3 id="reembolso-titulo" style="color:#c62828;margin:0 0 12px 0;font-size:20px;">Reembolso total</h3>
				<p style="margin:0 0 8px 0;"><strong>Pedido #${escapeHtml(orderId)}</strong></p>
				<p style="margin:0 0 8px 0;"><strong>Total a reembolsar:</strong> $${escapeHtml(totalFmt)}</p>
				<p style="color:#c62828;font-weight:700;margin:0 0 16px 0;">Esta acción no se puede deshacer.</p>
				<label for="reembolso-codigo-input" style="display:block;font-weight:700;margin-bottom:8px;">Escribe REEMBOLSAR para confirmar:</label>
				<input type="text" id="reembolso-codigo-input" autocomplete="off" placeholder="REEMBOLSAR" style="width:100%;box-sizing:border-box;padding:12px;border:2px solid #ddd;border-radius:6px;font-size:16px;text-align:center;letter-spacing:2px;font-weight:700;">
				<p id="reembolso-error" style="color:#c62828;min-height:20px;margin:8px 0 0 0;font-weight:600;"></p>
				<div style="margin-top:16px;text-align:right;">
					<button type="button" id="reembolso-cancelar-btn" style="margin-right:10px;padding:10px 16px;border:1px solid #bbb;border-radius:6px;background:#f5f5f5;cursor:pointer;">Cancelar</button>
					<button type="button" id="reembolso-confirmar-btn" style="padding:10px 16px;border:none;border-radius:6px;background:#c62828;color:#fff;font-weight:700;cursor:pointer;">Confirmar reembolso</button>
				</div>
			</div>`;
		document.body.appendChild(modal);

		const input = document.getElementById('reembolso-codigo-input');
		const errEl = document.getElementById('reembolso-error');
		const btnCancel = document.getElementById('reembolso-cancelar-btn');
		const btnOk = document.getElementById('reembolso-confirmar-btn');

		function setBusy(busy) {
			if (btnOk) {
				btnOk.disabled = busy;
				btnOk.textContent = busy ? 'Procesando...' : 'Confirmar reembolso';
			}
			if (btnCancel) btnCancel.disabled = busy;
			if (input) input.disabled = busy;
		}

		function confirmar() {
			const code = input ? String(input.value || '').trim() : '';
			const ok = String(code).toUpperCase().replace(/\s+/g, '') === 'REEMBOLSAR';
			if (!ok) {
				if (errEl) errEl.textContent = 'Escribe REEMBOLSAR para confirmar';
				if (input) {
					input.focus();
					input.select();
				}
				return;
			}
			if (errEl) errEl.textContent = '';
			setBusy(true);
			enviarReembolsoPedido(orderId, code, (success) => {
				if (!success) setBusy(false);
			});
		}

		if (btnCancel) btnCancel.onclick = () => cerrarModalReembolso();
		if (btnOk) btnOk.onclick = confirmar;
		modal.addEventListener('click', (e) => {
			if (e.target === modal) cerrarModalReembolso();
		});
		if (input) {
			input.addEventListener('keydown', (e) => {
				if (e.key === 'Enter') {
					e.preventDefault();
					confirmar();
				}
			});
		}
		document.addEventListener('keydown', onReembolsoEscape);
		win.setTimeout(() => {
			if (input) input.focus();
		}, 50);
	};

	win.mostrarReciboModal = function mostrarReciboModal(data) {
		if (!document.getElementById('modal-recibo-poskn')) {
			const modal = document.createElement('div');
			modal.id = 'modal-recibo-poskn';
			modal.style.cssText =
				'display: none; position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); z-index: 9999; align-items: center; justify-content: center;';
			modal.innerHTML =
				'<div id="recibo-content-poskn" style="background: #fff; padding: 20px; border-radius: 8px; min-width: 300px; max-width: 90vw; max-height: 90vh; overflow: auto; position: relative; box-shadow: 0 4px 20px rgba(0,0,0,0.3);"></div>';
			document.body.appendChild(modal);
		}

		let html = `
			<div style="text-align: center; margin-bottom: 20px;">
				<h2 style="margin: 0; color: #333;">Recibo Pedido #${data.id}</h2>
				<div style="margin-top: 10px; color: #666;">
					<div><strong>Fecha:</strong> ${escapeHtml(data.date)}</div>
					<div><strong>Cliente:</strong> ${escapeHtml(data.customer)}</div>
					<div><strong>Estado:</strong> ${escapeHtml(data.status)}</div>
					<div><strong>Método de pago:</strong> ${escapeHtml(data.payment)}</div>
		`;

		if (data.payment_details_full && data.payment_details_full.length > 0) {
			html += '<div style="margin-top: 8px; padding: 8px; background: #f8f9fa; border-radius: 4px;"><strong>Desglose:</strong>';
			data.payment_details_full.forEach((p) => {
				html += `<div>${formatCreditPaymentLine(win, p, data.tasa)}</div>`;
			});
			html += '</div>';
		}

		html += '</div></div><hr style="margin: 20px 0;"><table style="width: 100%; border-collapse: collapse;"><thead><tr style="background: #f8f9fa;"><th style="text-align: left; padding: 8px; border-bottom: 1px solid #ddd;">Producto</th><th style="text-align: center; padding: 8px; border-bottom: 1px solid #ddd;">Cant.</th><th style="text-align: right; padding: 8px; border-bottom: 1px solid #ddd;">Total</th></tr></thead><tbody>';

		data.items.forEach((item) => {
			const opcionesList =
				Array.isArray(item.ckn_options) && item.ckn_options.length > 0
					? item.ckn_options
					: Array.isArray(item.cknNames) && item.cknNames.length > 0
						? item.cknNames
						: [];
			const opciones =
				opcionesList.length > 0
					? `<br><small style="color:#111;">${opcionesList.map((n) => `- ${escapeHtml(n)}`).join('<br>')}</small>`
					: '';
			html += `<tr><td style="padding: 8px; border-bottom: 1px solid #eee;">${escapeHtml(item.name)}${opciones}</td><td style="text-align: center; padding: 8px; border-bottom: 1px solid #eee;">${item.qty}</td><td style="text-align: right; padding: 8px; border-bottom: 1px solid #eee;">${formatReceiptPrice(item.total)}</td></tr>`;
		});

		html += `</tbody></table><hr style="margin: 20px 0;"><div style="text-align: right;"><div style="margin-bottom: 5px;"><strong>Subtotal:</strong> ${formatReceiptPrice(data.subtotal)}</div><div style="margin-bottom: 20px; font-size: 18px; font-weight: bold; color: #333;"><strong>Total:</strong> ${formatReceiptPrice(data.total)}</div></div><div style="margin-top: 20px; text-align: center;"><button onclick="imprimirReciboPOSKN()" class="button button-primary" style="background: #007cba; color: white; border: none; padding: 10px 20px; border-radius: 4px; cursor: pointer; margin-right: 10px; font-size: 14px;">🖨️ Imprimir</button><button onclick="document.getElementById('modal-recibo-poskn').style.display='none'" class="button" style="background: #666; color: white; border: none; padding: 10px 20px; border-radius: 4px; cursor: pointer; font-size: 14px;">Cerrar</button></div>`;

		document.getElementById('recibo-content-poskn').innerHTML = html;
		document.getElementById('modal-recibo-poskn').style.display = 'flex';
		win.datosReciboActual = data;
	};

	win.imprimirReciboPOSKN = function imprimirReciboPOSKN() {
		if (!win.datosReciboActual) {
			win.mostrarNotificacion('❌ No hay datos de recibo para imprimir', 'error');
			return;
		}

		let anchoRecibo = win.localStorage.getItem('poskn_ancho_impresora') || '80';
		if (anchoRecibo === '2') anchoRecibo = '58';
		if (anchoRecibo === '3') anchoRecibo = '80';
		if (typeof win.posknResolvePaperWidth === 'function') {
			anchoRecibo = win.posknResolvePaperWidth(anchoRecibo);
		}
		const es58 = anchoRecibo === '58';
		const reciboWidthMm = es58 ? '58mm' : '80mm';
		const reciboFont = es58 ? '12px' : '13px';
		const reciboHeader = es58 ? '14px' : '16px';

		const datos = win.datosReciboActual;
		const cfg = win.POSKN_RECEIPT_CONFIG || {};
		const ahora = new Date();
		const fechaReporte = `${ahora.toLocaleDateString('es-ES')} ${ahora.toLocaleTimeString('es-ES')}`;

		let htmlImpresion = `<!DOCTYPE html><html><head><title>Recibo Pedido #${datos.id}</title><meta charset="UTF-8"><style>
			@media print { body { font-size: ${reciboFont}; margin: 0; padding: 2mm !important; } * { color: #000 !important; font-weight: 700 !important; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; } }
			* { box-sizing: border-box; margin: 0; padding: 0; color: #000; }
			body { font-family: 'Courier New', Courier, monospace; margin: 0 auto; padding: 2mm; font-size: ${reciboFont}; line-height: 1.25; font-weight: 700; color: #000; width: ${reciboWidthMm}; max-width: ${reciboWidthMm}; background: #fff; }
			.recibo { width: 100%; margin: 0 auto; color: #000; }
			.header { text-align: center; border-bottom: 1px dashed #000; padding-bottom: 4px; margin-bottom: 6px; }
			.header h2 { font-size: ${reciboHeader}; margin: 0 0 2px 0; font-weight: 900; color: #000; }
			.item { display: flex; justify-content: space-between; gap: 8px; margin: 3px 0; color: #000; }
			.total { border-top: 1px dashed #000; padding-top: 4px; margin-top: 6px; text-align: right; font-weight: 900; }
			small { color: #000 !important; font-weight: 700; }
			@page { size: ${reciboWidthMm} auto; margin: 0; }
		</style></head><body><div class="recibo"><div class="header"><h2>${escapeHtml(cfg.companyName || '')}</h2>`;

		if (cfg.companyDocument) {
			htmlImpresion += `<p>${escapeHtml(cfg.companyDocument)}</p>`;
		}
		htmlImpresion += `<p>Recibo #${datos.id}</p><p>${escapeHtml(datos.date || fechaReporte)}</p>`;
		if (cfg.companyAddress) htmlImpresion += `<p>${escapeHtml(cfg.companyAddress)}</p>`;
		if (cfg.companyPhones) htmlImpresion += `<p>${escapeHtml(cfg.companyPhones)}</p>`;
		htmlImpresion += `</div><div><p><strong>Cliente:</strong> ${escapeHtml(datos.customer || 'Cliente General')}</p><p><strong>Estado:</strong> ${escapeHtml(plainTextFromHtml(datos.status))}</p><p><strong>Pago:</strong> ${escapeHtml(plainTextFromHtml(datos.payment))}</p>`;

		if (datos.payment_details_full && datos.payment_details_full.length > 0) {
			datos.payment_details_full.forEach((p) => {
				htmlImpresion += `<p>${formatCreditPaymentLine(win, p, datos.tasa)
					.replace(/<small[^>]*>/g, '')
					.replace(/<\/small>/g, '')
					.replace(/style="[^"]*"/g, '')}</p>`;
			});
		}

		htmlImpresion += '</div><hr><div>';

		(datos.items || []).forEach((item) => {
			const opcionesList =
				Array.isArray(item.ckn_options) && item.ckn_options.length > 0
					? item.ckn_options
					: Array.isArray(item.cknNames) && item.cknNames.length > 0
						? item.cknNames
						: [];
			const opcionesSpan =
				opcionesList.length > 0
					? `<br><small>${opcionesList.map((n) => `- ${escapeHtml(n)}`).join('<br>')}</small>`
					: '';
			htmlImpresion += `<div class="item"><span>${escapeHtml(item.name)}${opcionesSpan} x${item.qty}</span><span>${formatReceiptPrice(item.total)}</span></div>`;
		});

		htmlImpresion += `</div><div class="total"><p>Subtotal: ${formatReceiptPrice(datos.subtotal)}</p><p>TOTAL: ${formatReceiptPrice(datos.total)}</p></div><div style="text-align: center; margin-top: 12px;"><p>¡Gracias por su compra!</p>`;
		if (cfg.companySocial) htmlImpresion += `<p>${escapeHtml(cfg.companySocial)}</p>`;
		if (cfg.companyFooter) htmlImpresion += `<p>${escapeHtml(cfg.companyFooter)}</p>`;
		if (cfg.showSystem) htmlImpresion += '<p>POSKN - ServiKN.com</p>';
		htmlImpresion += '</div></div></body></html>';

		let ticketTexto = '';
		if (typeof win.posknBuildThermalReceiptText === 'function') {
			try {
				ticketTexto = win.posknBuildThermalReceiptText(datos, {
					paperWidth: anchoRecibo,
					companyName: cfg.companyName || '',
					companyDocument: cfg.companyDocument || '',
					companyAddress: cfg.companyAddress || '',
					companyPhones: cfg.companyPhones || '',
					companySocial: cfg.companySocial || '',
					companyFooter: cfg.companyFooter || '',
					showSystem: !!cfg.showSystem,
					metodoEsBs: (metodo) => metodoEsBs(win, metodo),
				});
			} catch (eTexto) {
				console.warn('Recibo texto térmico falló, se usa HTML:', eTexto);
				ticketTexto = '';
			}
		}

		if (typeof win.posknPrint === 'function') {
			win.posknPrint({
				title: `Recibo Pedido #${datos.id}`,
				html: htmlImpresion,
				text: ticketTexto,
				paperWidth: anchoRecibo,
				kind: 'ticket',
			}).catch((err) => {
				win.mostrarNotificacion(
					'❌ Error al enviar a impresión: ' + (err && err.message ? err.message : err),
					'error',
				);
			});
			return;
		}

		win.mostrarNotificacion('❌ No hay puente de impresión (posknPrint)', 'error');
	};
}
